// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__a1Bdl","loading-container":"loading_loading-container__q4LLG","rotate":"loading_rotate__izafM","dash":"loading_dash__ldrRk"};